<template>
  <div class="InfoEdit">

    <div class="info_form">
      <van-form @submit="onSubmit(info_form)" :show-error="false" label-width="80" >

        <van-field
            v-model="info_form.patientName"
            name="patientName"
            label="姓名"
            maxlength="10"
            placeholder="请输入姓名"
            :rules="[{ required: true, message: '请填写姓名' }]"
        />

        <van-field
            v-model="info_form.idCardNo"
            name="idCardNo"
            label="身份证号"
            placeholder="请输入身份证号"
            :rules="[{ required: true, message: '请填写身份证号' },{ pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: '身份证号不正确' }]"
        />

        <van-field name="radio" label="性别">
          <template #input>
            <div v-if="info_form.gender === 0" style="width: 100%; display: flex; justify-content: flex-end;">女</div>
            <div v-else-if="info_form.gender === 1" style="width: 100%; display: flex; justify-content: flex-end;">男</div>
            <div v-else style="width: 100%; display: flex; justify-content: flex-end;">{{ info_form.gender }}</div>
          </template>
        </van-field>

        <van-field
            class="no_line"
            v-model="info_form.phoneNo"
            name="phoneNo"
            label="手机号"
            disabled
            placeholder="请输入手机号"
            :rules="[{ required: true, message: '手机号不正确' }]"
        />
<!--        { pattern: /^((13[0-9])|(14[0,1,4-9])|(15[0-3,5-9])|(16[2,5,6,7])|(17[0-8])|(18[0-9])|(19[0-3,5-9]))\d{8}$/, message: '身份证号不正确' }-->
        <div class="buttons">
          <van-button round block :loading="loadings" :disabled="loadings" loading-text="加载中..." type="info" native-type="onSubmit">保存</van-button>
        </div>

      </van-form>

    </div>

  </div>
</template>

<script>
export default {
  name: "infoDeta",
  data() {
    return{
      info_form: {
        patientName: "",
        gender: "",
        idCardNo: "",
        phoneNo: "",
        relationship: "",
        relationshipName: "",
        id: ""
      },
      loadings: false
    }
  },
  watch: {
    info_form: {
      handler(newVal) {
        if(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(newVal.idCardNo)) {
          if((newVal.idCardNo[newVal.idCardNo.length-2] % 2) == 0 ) {
            this.info_form.gender= 0;
          }else {
            this.info_form.gender= 1;
          }
        }else {
          this.info_form.gender= "--";
        }
      },
      deep: true
    }
  },
  created() {
    // 获取个人信息
    this.get_info();
  },
  mounted() {

  },
  methods: {
    // 用户个人信息
    get_info() {
      this.$get("user/detail")
        .then(res=> {
            if(res) {
              this.info_form= res.data;
              this.info_form.phoneNo= this.$route.query.phoneNo;
              console.log(this.info_form);
            }
        })
    },
    onSubmit(formName) {
      console.log(formName);
      this.loadings= true;
      this.$put("patient",formName)
        .then(res => {
          this.loadings= false;
          if(res) {
            this.$router.push({
              path: "/my"
            })
          }
        })
        .catch(() => {
          this.loadings= false;
        })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../../../style/My/Info/InfoEdit";
</style>
